module.exports = __webpack_public_path__ + "static/media/brand-icon-mobile.731cdc11.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/brand-icon-mobile.svg
 ** module id = 874
 ** module chunks = 0
 **/